/**
 * Default maximum number of characters allowed in a comment.
 * Override via inputConfig.maxAllowedCharacters.
 */
export const DEFAULT_MAX_COMMENT_LENGTH = 1000;
